import React, { useEffect } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const Lightbox = ({ photos, index, onClose, onNav }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onNav(1);
      if (e.key === "ArrowLeft") onNav(-1);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose, onNav]);

  return (
    <div
      className="fixed inset-0 z-[1000] bg-black/90 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="lightbox"
    >
      <button onClick={onClose} data-testid="lightbox-close" className="absolute top-4 right-4 text-white p-2">
        <X size={32} />
      </button>
      {photos.length > 1 && (
        <button
          onClick={(e) => { e.stopPropagation(); onNav(-1); }}
          data-testid="lightbox-prev"
          className="absolute left-2 sm:left-6 text-white p-2"
        >
          <ChevronLeft size={40} />
        </button>
      )}
      <img
        src={`${BACKEND}${photos[index]}`}
        alt=""
        onClick={(e) => e.stopPropagation()}
        className="max-h-[85vh] max-w-[90vw] object-contain"
      />
      {photos.length > 1 && (
        <button
          onClick={(e) => { e.stopPropagation(); onNav(1); }}
          data-testid="lightbox-next"
          className="absolute right-2 sm:right-6 text-white p-2"
        >
          <ChevronRight size={40} />
        </button>
      )}
      <span className="absolute bottom-5 text-white font-[600] text-sm">
        {index + 1} / {photos.length}
      </span>
    </div>
  );
};
